import React, { useEffect } from 'react';
// import React from 'react';
import SkynetLoader from '../../../../assets/compute/skynet/skynet-loader.gif';
import { useQuery } from '../../../../hooks/useQuery';
import { NODE_ENV } from '../../../../config';
// import Loader from '../../../../components/Compute/Loaders/loader';

const SkynetDashboard = () => {
  const queryParams = useQuery();
  const redirectUrl = queryParams.get('redirectUrl');

  useEffect(() => {
    if (!redirectUrl) {
      const skynetAppUrl =
        NODE_ENV === 'development'
          ? 'https://beta-dev.skynetxbt.ai'
          : 'https://beta.skynetxbt.ai';
      setTimeout(() => {
        window.open(skynetAppUrl, '_self');
      }, 4000);
    }
  }, [redirectUrl]);

  return (
    <div className="h-screen w-screen flex flex-row justify-center items-center">
      <img
        src={SkynetLoader}
        alt="Loading Skynet..."
        width={200}
        height={200}
        className="mix-blend-lighten"
      />
    </div>
  );
};

export default SkynetDashboard;
